<template>
  <expand-transition>
    <sb-panel
      v-if="organizationMfaRequired && !userMfaEnabled"
      variation="info"
      icon-orientation="start"
      class="mfa-banner"
    >
      <div class="mfa-banner-container">
        <div class="mfa-banner-left-container">
          <div class="vertical-line" />
          <div class="mfa-banner-content">
            <span class="bold-text">{{ $t('title') }}</span>
            <br>
            <span>
              {{ $t('subTitle') }}
              <span v-if="!isSubaccountUser">
                {{ $t('LearnMoreText') }}
                <a
                  class="link bold-text"
                  @click="mfaHelpArticle"
                >
                  {{ $t('clickHereText') }}
                </a>
              </span>
            </span>
          </div>
        </div>
        <sb-button @click.prevent="setupMfa">
          {{ $t('buttonText') }}
        </sb-button>
      </div>
    </sb-panel>
  </expand-transition>
</template>

<script>

import UserService from '@/services/user'

export default {
  name: 'SetupMfaBanner',
  data () {
    return {
      organizationMfaRequired: false,
      userMfaEnabled: false,
      isSubaccountUser: false
    }
  },
  async mounted () {
    const response = await UserService.getMyProfileInfo()
    if (response.success) {
      const userInfo = response.data
      this.organizationMfaRequired = userInfo.mfaRequired
      this.userMfaEnabled = userInfo.twoFactorEnabled
    }

    const oneIdClaim = this.$shipBobStore.getters['user/getOneIdClaim']
    this.isSubaccountUser = oneIdClaim.org_atts.external_type_id !== ''
  },
  methods: {
    setupMfa () {
      this.$router.push({ path: '/user-management/my-profile' })
    },
    mfaHelpArticle () {
      window.open(this.$t('mfaHelpArticleLink'), '_blank')
    }
  },
  i18n: {
    messages: {
      'en-US': {
        title: 'Set up multi-factor authentication',
        subTitle: 'Your account admin has enforced an extra layer of security to your account, you will need to set up an authentication method. Go to My Profile page for set up. ',
        LearnMoreText: 'To learn more, ',
        clickHereText: 'click here',
        mfaHelpArticleLink: 'https://support.shipbob.com/s/article/Multi-Factor-Authentication',
        buttonText: 'Setup'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './scss/banner';

.mfa-banner {
  width: calc(100% - 2rem);
  margin-left: 1rem;
  margin-top: 1rem;
  align-items: center;

  .mfa-banner-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .mfa-banner-left-container {
      display: flex;
      max-width: 85%;
    }
  }

  .bold-text {
    font-weight: bold;
  }

  .link {
    text-decoration: none;
    color: inherit;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
